module.exports = __webpack_public_path__ + "static/img/webdesign-03.2cfc71fd.png";